import React, { useState } from "react";
import { blogContent } from "./blogConstants";
import BlogCard from "../../common/BlogCard";
import { Input } from "reactstrap";
import searchIcon from "../../../assets/Icon-right.png";
import { Link } from "react-router-dom";

function compareFn(a, b) {
  const dateA = new Date(a.date).getTime();
  const dateB = new Date(b.date).getTime();

  if (dateA > dateB) {
    return -1;
  } else if (dateA < dateB) {
    return 1;
  }

  return 0;
}

const NewsShelter = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredBlogs = blogContent
    .filter(({ title, description }) =>
      `${title} ${description}`.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort(compareFn);

  return (
    <div className="max-w-[1200px] flex flex-col justify-center items-center gap-8 max-xl:px-6">
      <div className="w-full lg:w-[448px] rounded-lg p-0 relative">
        <Input
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-4 pr-10 py-3.5 bg-[#FFFFFF] border border-[#E5E7EB] rounded-lg shadow-[0px_1px_2px_0px_#1018280A,0px_1px_2px_0px_#1018280A] w-full text-base"
        />
        <img
          src={searchIcon}
          alt="Search Icon"
          style={{ position: "absolute", top: 16, right: 16 }}
        />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {filteredBlogs.length > 0 ? (
          filteredBlogs.map(
            ({ blogId, date, description, title, displayImage }, index) => (
              <Link key={index} to={`/blog/${blogId}`}>
                <BlogCard
                  date={date}
                  title={title}
                  description={description}
                  displayImage={displayImage}
                />
              </Link>
            )
          )
        ) : (
          <p className="text-gray-500 col-span-3">No matching blogs found.</p>
        )}
      </div>

      {/* <button className="text-darkPurple py-3 w-[7.75rem] h-13 text-sm rounded-full border-2 border-darkPurple bg-white hover:bg-[#f8f8f8] transition-all">
        Load More
      </button> */}
    </div>
  );
};

export default NewsShelter;
